module.exports = __webpack_public_path__ + "img/box-open-solid 1.51517470.svg";